import { Image } from "@chakra-ui/react";

type Props = {
  available?: boolean;
};

export function AvailibilityIcon({ available = false }: Props) {
  return (
    <Image
      h={4}
      src={available ? "/svg/available.svg" : "/svg/not-available.svg"}
      w={4}
    />
  );
}
